"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var StorySpacer = function (_a) {
    var children = _a.children, constrain = _a.constrain, className = _a.className;
    return (react_1.default.createElement("div", { className: "p-4 " + (constrain ? 'max-w-lg' : '') + " " + (className || '') }, children));
};
exports.default = StorySpacer;
//# sourceMappingURL=index.js.map